import gql from 'graphql-tag';
import { PROJECT_BANK_ATTACHMENT_SELECTION } from './projectBankAttachmentSelection';

/**
 * Data of the block project-bank-customer ("Kunde", tab Bank): its fields of `bank` and the bank attachments of its types. Read through
 * `Project.blocks.bankCustomer`, which checks the block's read permission.
 */
export const PROJECT_BANK_CUSTOMER_FIELDS = gql`
  fragment projectBankCustomerFields on ProjectBankCustomerBlock {
    id
    number
    bank {
      prospectiveCustomer
      gbrStatus
      ${PROJECT_BANK_ATTACHMENT_SELECTION}
    }
  }
`;
